export default __webpack_public_path__ + "files/TN_Nitrate_Trend_Catchments-73d0818e651ff5552f1a06d8f71de831.pbf";